import React from "react";
import { isEmpty } from "lodash";
import {
  Modal,
  ModalBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { ReactComponent as CrossSvg } from "assets/images/heylime-layout/cross.svg";
import { ReactComponent as DownArrowSvg } from "assets/images/heylime-layout/pricing-arrow.svg";

const OnboardingModal = ({
  isOpen,
  toggle,
  desc = "",
  users = [],
  title = "",
  btnText1 = "",
  btnText2 = "",
  inputValue = "",
  bottomText = "",
  inputType = "text",
  dropdown = false,
  isDropdown = false,
  dropdownValue = {},
  btnClick1 = () => {},
  btnClick2 = () => {},
  inputDisabled = false,
  inputOnChange = () => {},
  dropdownSelect = () => {},
  toggleDropDown = () => {}
}) => {
  return (
    <Modal
      centered
      isOpen={isOpen}
      toggle={toggle}
      backdropClassName="onboarding-modal-backdrop"
      className={`onboarding-modal ${inputType === "" ? "edit-manager" : ""} ${
        btnText2 !== "" ? "wide" : ""
      }`}
    >
      <ModalBody>
        <div className="modal-inner">
          <div className="header">
            <h2 className="title">{title}</h2>
            <div className="cross-icon">
              <CrossSvg onClick={toggle} className="modal-cross" />
            </div>
          </div>
          <div className="body">
            <p className="desc">{desc}</p>
            {inputType !== "" && (
              <input
                name="quantity"
                type={inputType}
                value={inputValue}
                className="input-div"
                disabled={inputDisabled}
                onChange={inputOnChange}
                placeholder="Enter Quantity"
              />
            )}
            {isDropdown && (
              <Dropdown isOpen={dropdown} toggle={toggleDropDown}>
                <DropdownToggle caret>
                  {dropdownValue.name || "Select Teammate"}
                  <DownArrowSvg />
                </DropdownToggle>
                {!isEmpty(users) && (
                  <DropdownMenu>
                    {users?.map((user, index) => (
                      <DropdownItem
                        key={index}
                        onClick={() => dropdownSelect(user)}
                      >
                        {user.name}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                )}
              </Dropdown>
            )}
            <div className="btn-div">
              <button
                className={`blender-btn ${btnText2 !== "" ? "btnColor" : ""}`}
                onClick={btnClick1}
              >
                {btnText1}
              </button>
              {btnText2 !== "" && (
                <button className="blender-btn" onClick={btnClick2}>
                  {btnText2}
                </button>
              )}
            </div>
            {bottomText !== "" && bottomText}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default OnboardingModal;
